<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Destination List</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container margin_60_35">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-9">
            <div class="isotope-wrapper">
              <form @submit.prevent="createDestination()" method="post">
                <div class="row custom-search-input-2">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label style="padding: 0 12px"
                        >Starting From {{ travelling_from }} ON
                        {{ starting_from }}</label
                      >
                    </div>
                  </div>
                  <div class="col-md-12">
                    <table class="table">
                      <tr
                        v-for="destination in destinationList"
                        :key="destination.id"
                      >
                        <td>To: {{ destination.to_destination }}</td>
                        <td>Arrival Date: {{ destination.arrival_date }}</td>
                        <td>
                          Departure Date: {{ destination.departure_date }}
                        </td>
                        <td>
                          <a @click="removeRow(destination.id, destination)"
                            >X</a
                          >
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Stopping Points</label>
                      <input
                        class="form-control"
                        v-model="to_destination"
                        type="text"
                        placeholder="Stopping Points.."
                      />
                      <i class="icon-home"></i>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Arrival Date</label>
                      <!-- <input
                        class="form-control"
                        v-model="arrival_date"
                        type="datetime-local"
                        placeholder="Arrival Date.."
                      /> -->
                      <date-picker
                        v-model="arrival_date"
                        :config="arrivalDateConfig"
                      ></date-picker>
                      <!-- <i class="icon_calendar"></i> -->
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Departure Date</label>
                      <date-picker
                        v-model="departure_date"
                        :config="departureDateConfig"
                      ></date-picker>
                      <!-- <input
                        class="form-control"
                        v-model="departure_date"
                        type="datetime-local"
                        placeholder="Departure Date.."
                      /> -->
                      <!-- <i class="icon_calendar"></i> -->
                    </div>
                  </div>
                  <div class="col-md-12">
                    <alert
                      v-if="msg"
                      :msg="msg"
                      :classAlert="classAlert"
                    ></alert>

                    <div id="pass-info" class="clearfix"></div>
                    <button type="submit" class="btn_1 add_top_30">
                      Add More Destination</button
                    ><br /><br />
                    <a href="/my-journey" class="btn_1 full-width purchase">
                      Finish
                    </a>
                  </div>
                </div>
              </form>
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import moment from "moment";
import Alert from "../cmps/Alert";
import API from "../services/index";
import router from "../routes";
import Sidebar from "../layouts/Sidebar.vue";
import Frontendlayout from "../layouts/Frontendlayout.vue";

export default {
  data() {
    return {
      to_destination: "",
      //arrival_date: "",
      //departure_date: "",
      arrival_date: "",
      arrivalDateConfig: {},
      departure_date: "",
      departureDateConfig: {},
      user_journey_id: null,
      msg: null,
      classAlert: null,
      destinationList: [],
      journeydetails: [],
      travelling_from: "",
      travelling_to: "",
      starting_from: "",
      till_date: "",
    };
  },
  beforeMount() {
    this.getDestinationList(),
      this.getJourneydetails(),
      this.checkToken(),
      this.checkId();
  },

  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        router.push("/signin");
      }
    },

    checkId() {
      let id = this.$router.currentRoute.params.id;
      // alert(id);
      if (id == null) {
        router.push("/journey-planner");
      }
    },

    removeRow: function (DestinationId, row) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      let id = window.atob(this.$router.currentRoute.params.id);
      //alert(id);
      const form = new FormData();
      form.append("user_journey_id", id);
      form.append("is_active", 0);

      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
      // this.$api
      //   .post("userjourney/remove_destination/" + window.btoa(DestinationId), {
      //     headers: { Authorization: token },
      //   })
      API.post(
        "/userjourney/remove_destination/" + window.btoa(DestinationId),
        form,
        {
          headers: { Authorization: token },
        }
      )
        .then((res) => {
          if (res.data.status == 200) {
            Toast.fire({
              icon: "Success",
              title: res.data.messages,
            });
            this.destinationList.$remove(row);
            this.getDestinationList();
          } else {
            Toast.fire({
              icon: "error",
              title: res.data.messages,
            });
          }
          this.getDestinationList();
        })
        .catch((err) => {
          console.log(err.response);
        });
      //this.rows.$remove(row);
    },

    getJourneydetails() {
      let id = this.$router.currentRoute.params.id;
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
        API.get("userjourney/get_journey_details/" + id, {
          headers: { Authorization: token },
        })
        .then((res) => {
          this.journeyDetails = res.data;
          this.travelling_from = res.data.travelling_from;
          this.travelling_to = res.data.travelling_to;
          this.starting_from = moment(
            res.data.from_date,
            "YYYY-MM-DD H:mm:ss"
          ).format("DD/MM/YYYY hh:mm a");
          this.till_date = res.data.to_date;
          // alert(res.data.from_date);
          // alert(
          //   moment(res.data.from_date, "YYYY-MM-DD H:mm:ss").format(
          //     "DD/MM/YYYY hh:mm a"
          //   )
          // );
          this.arrivalDateConfig = {
            format: "DD/MM/YYYY hh:mm a",
            useCurrent: false,
            minDate: moment(res.data.from_date, "YYYY-MM-DD H:mm:ss").format(
              "DD/MM/YYYY hh:mm a"
            ),
            maxDate: moment(res.data.to_date, "YYYY-MM-DD H:mm:ss").format(
              "DD/MM/YYYY hh:mm a"
            ),
          };
          this.departureDateConfig = {
            format: "DD/MM/YYYY hh:mm a",
            useCurrent: false,
            minDate: moment(res.data.from_date, "YYYY-MM-DD H:mm:ss").format(
              "DD/MM/YYYY hh:mm a"
            ),
            maxDate: moment(res.data.to_date, "YYYY-MM-DD H:mm:ss").format(
              "DD/MM/YYYY hh:mm a"
            ),
          };
        })
        .catch((err) => {
          console.log(err.response);
        });
    }, 

    getDestinationList() {
      let id = this.$router.currentRoute.params.id;
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
        API.get("userjourney/get_destination_list/" + id, {
          headers: { Authorization: token },
        })
        .then((res) => {
          this.destinationList = res.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    createDestination() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-right",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      if (
        this.to_destination == "" ||
        this.arrival_date == "" ||
        this.departure_date == ""
      ) {
        Toast.fire({
          icon: "Error",
          title: "All fields are mandatory",
        });
        return;
      }
      const form = new FormData();
      form.append(
        "user_journey_destinations[0][to_destination]",
        this.to_destination
      );
      form.append(
        "user_journey_destinations[0][arrival_date]",
        this.arrival_date
      );
      form.append(
        "user_journey_destinations[0][departure_date]",
        this.departure_date
      );
      //form.append("user_journey_id", id);
      let id = this.$router.currentRoute.params.id;
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);

      API.post("/userjourney/add_destinationlist/" + id, form, {
        headers: { Authorization: token },
      })
        .then((res) => {
          console.log(res.data.messages);
          if (res.data.status == 200) {
            Toast.fire({
              icon: "Success",
              title: res.data.messages,
            });
            this.to_destination = "";
            this.arrival_date = "";
            this.departure_date = "";
            this.user_journey_id = "";
            this.getDestinationList();
            // router.push("/");
          } else {
            Toast.fire({
              icon: "Error",
              title: res.data.messages,
            });
          }
        })
        .catch((err) => {
          Toast.fire({
            icon: "Error",
            title: err.response.data.messages.error,
          });
        });
      //axios
    },
  },
  components: {
    Alert,
    Frontendlayout,
    Sidebar,
  },
};
</script>
<style  scoped>
.custom-search-input-2 input {
  border: 1px solid #d2d8dd !important;
}
.custom-search-input-2 {
  padding: 20px !important;
}
.form-group {
  margin-bottom: 30px;
}
.custom-search-input-2 i {
  top: 35px;
  height: unset !important;
  line-height: unset;
}
.custom-search-input-2 input {
  height: 35px;
}
figure img {
  width: 439px;
  height: 310px;
  margin-top: 17px;
}
#sidebar {
  margin-top: 15px;
}
</style>